import * as React from "react";

function SvgMillennialMedia(props, ref) {
  return (
    <svg
      id="MillennialMedia_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 79.6 79.6"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>{".MillennialMedia_svg__st0{fill:#70b926}"}</style>
      <path
        className="MillennialMedia_svg__st0"
        d="M24.5 49.5c1.6 5.5 5.1 9.1 10.5 10.7 6.2 1.8 11.8.2 16.3-4.5C55 51.9 57.6 45 53.7 37c.2 0 .3 0 .5.1C64 42.2 70.3 50 72.9 60.8c.1.5 0 1.2-.3 1.6-6.7 9.3-15.6 15.1-27 16.7-13.2 1.9-24.6-2-34-11.3-2-2-3.6-4.4-5.4-6.7-.3-.4-.4-1.2-.3-1.7C9 48.6 15.8 41 26 36.4c3.3-1.5 7-.3 9.1 2.7 2 2.9 1.8 6.8-.6 9.4-2.5 2.7-6.2 3.3-9.4 1.5-.2-.2-.4-.3-.6-.5z"
      />
      <path
        className="MillennialMedia_svg__st0"
        d="M79 45.7c-9-14.2-21.7-22.5-38.8-22.9C23 22.5 10.1 30.5.4 44.2-1.3 33.9 2.5 17.3 17.1 7.1 31.3-2.8 50.3-2.3 64 8.2c13.7 10.6 17.2 26.9 15 37.5z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgMillennialMedia);
